import styled from 'styled-components';
import { TextMessage } from '@omilia/chat-ui';
import { colors } from '@omilia/theme';
import { MessageStatus } from 'types';
import Logo from 'components/Logo';

const statusBackgroundColor = {
  [MessageStatus.PENDING]: colors.COLOR_GREY_100,
  [MessageStatus.ERROR]: colors.COLOR_RED_100,
  [MessageStatus.SENT]: null,
};

const statusBorder = {
  [MessageStatus.PENDING]: `1px solid ${colors.COLOR_GREY_900}`,
  [MessageStatus.ERROR]: `1px solid ${colors.COLOR_RED_700}`,
  [MessageStatus.SENT]: null,
};

const statusColor = {
  [MessageStatus.PENDING]: colors.COLOR_GREY_900,
  [MessageStatus.ERROR]: colors.COLOR_RED_700,
  [MessageStatus.SENT]: null,
};

export const SThreadItemContainer = styled.div<{
  isMessage?: boolean;
  isBot: boolean;
}>`
  align-items: ${({ isBot }) => (isBot ? 'flex-start' : 'flex-end')};
  display: flex;
  flex-direction: ${({ isMessage }) => (isMessage ? 'column' : 'row')};
  justify-content: ${({ isMessage }) =>
    isMessage ? 'flex-end' : 'flex-start'};
  word-break: break-word;
`;

export const SOwner = styled.span`
  color: ${colors.COLOR_GREY_800};
  font-size: 12px;
  margin: 0 0 6px 40px;
`;

export const SMessageWrapper = styled.div<{
  showAvatar?: boolean;
}>`
  align-items: flex-end;
  display: flex;
  justify-content: flex-start;
  margin: ${({ showAvatar }) => (showAvatar ? '0 0 16px 0' : '0 0 8px 40px')};
`;

export const SUserMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
`;

export const SUserMessage = styled(TextMessage)<{
  status?: MessageStatus;
}>`
  background-color: ${({ status }) => statusBackgroundColor[status]};
  border: ${({ status }) => statusBorder[status]};
  color: ${({ status }) => statusColor[status]};
`;

export const SMessageStatusIcon = styled.div`
  margin: 4px 4px 0 0;
`;

export const SLogo = styled(Logo)`
  height: 32px;
  margin-left: 0;
  margin-right: 8px;
  width: 32px;
`;

export const SUiComponentWrapper = styled.div<{
  showAvatar?: boolean;
}>`
  align-items: flex-end;
  display: flex;
  margin: ${({ showAvatar }) => (showAvatar ? '0 0 16px 0' : '0 0 8px 40px')};
`;

export const STextMessage = styled(TextMessage)`
  display: inline;
  overflow: hidden;
  a {
    white-space: normal;
    word-wrap: break-word;
  }
`;

export const SInnerMessageWrapper = styled.span`
  display: flex;
  align-items: center;

  button {
    margin-right: 4px;

    &:hover {
      background-color: transparent;
    }
  }
`;

export const SFileMessage = styled.div`
  align-items: end;
  display: flex;
  justify-content: end;
  margin-bottom: 16px;

  & > button {
    margin-bottom: 16px;
  }
`;

export const SFileGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
